import { AppRootStateType } from 'state/reducers';

export const selectIsPlaying = (state: AppRootStateType): boolean =>
  state.player.isPlaying;
export const selectEndTime = (state: AppRootStateType): number => state.player.endTime;
